/**
 * Used for displaying ObjectStatus with the right color for process instance statuses.
 * Colors are:
 * color grey, ObjectStatus.state: None
 * color orange, ObjectStatus.state: Warning
 * color green, ObjectStatus.state: Success
 * color red, ObjectStatus.state: Error
 * color blue, ObjectStatus.state: Information
 * color purple, ObjectStatus.state: Indication06
 * @returns state parameter for ObjectStatus
 */
export function GetStateForSpecificationStatus(status: string): string {
  switch (status) {
    case "finished":
      return "Indication14";
    case "closed":
      return "Success";
    case "cancelled":
      return "Error";
    case "draft":
      return "Indication19";
    default:
      return "None";
  }
}

export function GetButtonTypeForSpecificationStatus(status: string): string {
  switch (status) {
    case "finished":
      return "Success";
    case "rejected":
      return "Reject";
    case "cancelled":
      return "Negative";
    case "closed":
      return "Success";
    case "draft":
    default:
      return "Neutral";
  }
}

export function GetTextKeyForSpecificationStatusButton(status: string): string {
  switch (status) {
    case "finished":
      return "toFinished";
    case "rejected":
      return "toRejected";
    case "closed":
      return "toClosed";
    case "cancelled":
      return "toCancelled";
    case "draft":
      return "toDraft";
    default:
      console.error("Unknown specification status: " + status);
      return status;
  }
}
